import { Checkbox as AntCheckbox, CheckboxProps as AntCheckboxProps } from 'antd';
import styles from './checkbox.module.scss';

type CheckboxProps = AntCheckboxProps & {
  children?: React.ReactNode;
};

export function Checkbox({ children, className, ...props }: CheckboxProps) {
  return (
    <AntCheckbox className={`${styles.checkbox} ${className || ''}`} {...props}>
      {children}
    </AntCheckbox>
  );
}
